import { TfiCup } from "react-icons/tfi";
import { RiBookMarkLine } from "react-icons/ri";
import { LuClock4 } from "react-icons/lu";

import Button from "@/components/Button";
import CourseDetail from "./CourseDetail";
import CourseInfo from "./CourseInfo";
import { useParams } from "react-router-dom";
import { secondsToTime } from "./../../../../utils/helpers";

function CourseCard({ course }) {
        const { school_level ,grade } = useParams();


    const { id, quizzesCount, videosCount, videosDuration } = course;
    const { name, brief, type } = course.attributes;

    // TODO
    // if (videosCount === 0 && quizzesCount === 0) return <p>not</p>;
    return (
        <div className="relative flex flex-col items-center justify-between gap-4 pb-4 my-10 2xl:gap-0 md:p-6 rounded-2xl 2xl:flex-row bg-primary-color-mid ">
            <span
                className={`absolute top-0 ${
                    type === 1 ? "bg-green-color" : "bg-secondary-color"
                } text-xs font-medium text-white text-center p-0.5 leading-none rounded-full px-3 py-1 -translate-y-1/2 translate-x-1/2 right-1/2`}
            >
                {type === 1 ? "اونلاين" : "سنتر"}
            </span>
            <div className="flex flex-col items-center justify-center gap-2 p-4 md:gap-8 2xl:flex-row md:p-10">
                {/* img */}
                <div className="w-100">
                    <img
                        src="/images/courses/courseImage.webp"
                        alt="course icon"
                        className="w-100"
                        loading="lazy"
                        decoding="async"
                    />
                </div>
                {/*  */}
                <div className="flex flex-col gap-3 text-center 2xl:gap-0 2xl:text-start 2xl:block ">
                    {/* name and breif */}
                    <CourseInfo
                        name={name}
                        brief={brief}
                        maxName={10}
                        maxBrief={30}
                    />

                    {/* courseDetail */}
                    <div className="flex flex-wrap items-center gap-2 px-3 py-2 bg-white justify-evenly rounded-2xl">
                        <CourseDetail
                            title={"فيديوهات"}
                            icon={
                                <RiBookMarkLine className="text-lg text-gray-color-primary" />
                            }
                            value={videosCount}
                        />
                        <CourseDetail
                            title={"امتحان"}
                            icon={
                                <TfiCup className="text-lg text-gray-color-primary" />
                            }
                            value={quizzesCount}
                        />
                        <CourseDetail
                            title={"ساعات"}
                            icon={
                                <LuClock4 className="text-lg text-gray-color-primary" />
                            }
                            value={secondsToTime(videosDuration)}
                        />
                    </div>
                </div>
            </div>
            <div className="flex ">
                <Button
                    name="go to the course lectures page"
                    to={`/${grade}/courses/${id}`}
                    type="primary"
                    className="w-40 text-center"
                >
                    الدخول
                </Button>
            </div>
        </div>
    );
}

export default CourseCard;
